customElements.whenDefined('variant-selects').then(() => {
  const VariantSelects = customElements.get('variant-selects');
  if (!VariantSelects) return;

  const p = VariantSelects.prototype;
  const originalConnectedCallback = p.connectedCallback;
  const originalRenderVariantInfo = p.renderVariantInfo;

  p.connectedCallback = function () {
    this.productWrapper = this.closest('.thb-product-detail');
    const scope = this.productWrapper || this.closest('section') || document;

    this.other = Array.from(scope.querySelectorAll('variant-selects')).filter((selector) =>
      selector !== this &&
      selector.dataset.productId === this.dataset.productId &&
      selector.dataset.section === this.dataset.section
    );

    return originalConnectedCallback.apply(this, arguments);
  };

  p.updateOther = function () {
    if (this.dataset.updateUrl === 'false') return;

    const other = (this.other || []).find((selector) =>
      selector !== this &&
      selector.dataset.productId === this.dataset.productId &&
      selector.dataset.section === this.dataset.section
    );

    if (!other) return;

    const fieldsets = Array.from(other.querySelectorAll('fieldset'));
    this.options.forEach((option, i) => {
      const fieldset = fieldsets[i];
      if (!fieldset) return;

      const select = fieldset.querySelector('select');
      if (select) {
        select.value = option;
        return;
      }

      const input = Array.from(fieldset.querySelectorAll('input')).find((el) => el.value === option);
      if (input) input.checked = true;
    });

    other.updateOptions();
    other.updateMasterId();
    other.updateVariantText();
    other.setDisabled();
  };

  p.getScopedSubmitButtons = function () {
    const wrapper = this.productWrapper || this.closest('.thb-product-detail');
    return wrapper ? Array.from(wrapper.querySelectorAll('.single-add-to-cart-button')) : [];
  };

  p.toggleAddButton = function (disable = true, text = false, modifyClass = true) {
    const wrapper = this.productWrapper || this.closest('.thb-product-detail');
    const productForm = wrapper ? wrapper.querySelector(`#product-form-${this.dataset.section}`) : null;
    if (!productForm) return;

    const productFormElement = productForm.closest('.product-form');
    const productTemplate = productFormElement ? productFormElement.getAttribute('template') : '';
    const submitButtons = this.getScopedSubmitButtons();

    submitButtons.forEach((submitButton) => {
      const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
      if (!submitButtonText) return;

      if (disable) {
        submitButton.setAttribute('disabled', 'disabled');
        if (text) submitButtonText.textContent = text;
      } else {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading', 'sold-out');

        if (productTemplate && productTemplate.includes('pre-order')) {
          submitButtonText.textContent = window.theme.variantStrings.preOrder;
        } else {
          submitButtonText.textContent = text || window.theme.variantStrings.addToCart;
        }
      }
    });

    if (!modifyClass) return;
  };

  p.setUnavailable = function () {
    const submitButtons = this.getScopedSubmitButtons();
    const wrapper = this.productWrapper || this.closest('.thb-product-detail');
    const price = wrapper ? wrapper.querySelector(`#price-${this.dataset.section}`) : null;
    const priceFixed = wrapper ? wrapper.querySelector(`#price-${this.dataset.section}--sticky`) : null;

    submitButtons.forEach((submitButton) => {
      const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
      if (!submitButtonText) return;
      submitButtonText.textContent = window.theme.variantStrings.unavailable;
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.classList.add('sold-out');
    });

    if (price) price.classList.add('visibility-hidden');
    if (priceFixed) priceFixed.classList.add('visibility-hidden');
  };

  p.renderVariantInfo = function () {
    const ids = this.getSelectedValueIds();
    if (!ids.length) {
      this.toggleAddButton(
        this.currentVariant ? !this.currentVariant.available : false,
        this.currentVariant ? window.theme.variantStrings.soldOut : window.theme.variantStrings.addToCart
      );
      return;
    }
    return originalRenderVariantInfo.apply(this, arguments);
  };
});
